module.exports = __webpack_public_path__ + "static/img/srvu-logo.10be369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/srvu-logo.png
// module id = /0+Z
// module chunks = 1